import { useEffect, useState } from "react";
import { PulseSharedObject } from "@features/pulse/variant/others/utils/types";
import axios from "axios";

/**
 * This hook fetches and manages the share count for a given article.
 * It provides functionality to increment the share count and returns the current share count
 */
export const useGetShareCount = (articleId: string) => {
  const [shareCount, setShareCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!articleId) return;

    const fetchShareCount = async () => {
      try {
        const response = await axios.get<PulseSharedObject>(
          "/_plat/api/v1/article/share",
          {
            params: { article_id: articleId },
          }
        );

        const shareData = response.data;
        const shareCount = shareData?.share_count || 0;

        setShareCount(shareCount);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching share count:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchShareCount();
  }, [articleId]);

  const incrementShareCount = async () => {
    if (!articleId) return;

    try {
      const apiPayload = {
        article_id: articleId,
      };

      const response = await axios.post(
        "/_plat/api/v1/article/share",
        apiPayload,
        {
          timeout: 10000,
        }
      );
      const shareData = response.data;
      const shareCount = shareData?.share_count || 0;

      setShareCount(shareCount);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error increment share count:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { shareCount, isLoading, incrementShareCount };
};
